import { motion } from "framer-motion";
import { useState } from "react";
import { FiChevronDown } from 'react-icons/fi';
import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";

const MenuItem = ({ title = "", Icon, submenus = [], link = "", notification = false, menuOpen }) => {
    const location = useLocation();
    const [open, setOpen] = useState();

    useEffect(() => {
        setOpen(submenus.length && location.pathname.split("/").includes(link))
    }, [])

    return (
        <motion.div animate={open ? "open" : "closed"} className={`relative w-full`}>
            <button
                onClick={() => { setOpen((pv) => !pv); menuOpen() }}
                className={`w-full rounded flex ${location.pathname === link ? 'bg-nt-blue text-white pointer-events-none' : ''}`}
            >
                <Link className={`no-underline p-2 gap-3 h-full  w-full items-center flex flex-row text-nt-blue group-hover:text-white ${location.pathname === link ? ' text-white' : ''}`} to={link}>
                    <Icon />
                    <p className="flex-1 text-left font-medium">
                        {submenus.length ? title : title}
                        {submenus.length > 0 && <motion.span variants={iconVariants} className="ml-auto">
                            <FiChevronDown />
                        </motion.span>}
                    </p>
                    {typeof notification === 'number' && notification > 0 ? (
                        <span className="shrink-0 bg-nt-red text-white text-xs font-semibold rounded-full min-w-[1.5rem] h-6 px-1.5 flex items-center justify-center">
                            {notification > 99 ? '99+' : notification}
                        </span>
                    ) : null}
                </Link>
            </button>

            <motion.ul
                initial={wrapperVariants.closed}
                variants={wrapperVariants}
                className="m-0 ml-[30px] flex flex-col text-nt-blue"
            >
                {submenus.map((menu, i) => {
                    return (<Option key={i} text={menu.text} link={menu.link} location={location} />)
                })}
            </motion.ul>
        </motion.div>
    )
}

const Option = ({ text, link, location }) => {
    return (
        <motion.li
            variants={itemVariants}
            className={`group mb-1 flex w-full cursor-pointer flex-row items-center gap-2.5 rounded-[5px] px-2.5 py-2.5 hover:bg-nt-red hover:text-white ${location.pathname === link ? "pointer-events-none bg-nt-blue text-white" : ""}`}
        >
            {/* <motion.span variants={actionIconVariants}>
                <Icon />
            </motion.span> */}
            <Link
                className={`mb-2 block w-full rounded-[5px] no-underline ${location.pathname === link ? "text-white" : "text-nt-blue group-hover:text-white"}`}
                to={link}
            >
                <span>{text}</span>
            </Link>

        </motion.li>
    );
};
const wrapperVariants = {
    open: {
        scaleY: 1,
        transition: {
            when: "beforeChildren",
        },
        height: "auto",
    },
    closed: {
        scaleY: 0,
        transition: {
            when: "afterChildren",
        },
        height: 0,
    },
};

const iconVariants = {
    open: { rotate: 180 },
    closed: { rotate: 0 },
};

const itemVariants = {
    open: {
        opacity: 1,
        y: 0,
        transition: {
            when: "beforeChildren",
        },
    },
    closed: {
        opacity: 0,
        y: -5,
        transition: {
            when: "afterChildren",
        },
    },
};

export { MenuItem }